import React, { useContext } from "react";
import { Offcanvas } from "react-bootstrap";
import { Context } from "../../../_context/Store";

function UiSidePanel() {
    const [state, dispatch] = useContext(Context);

    const handleClose = () => {
        dispatch({
            type: "SIDE_PANEL",
            payload: { show: false },
        });
    };

    return (
        <>
            <Offcanvas
                show={state.ui_side_panel.show}
                onHide={handleClose}
                placement="end"
                className="sb-side-panel-wr"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        {state.ui_side_panel.title}
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>{state.ui_side_panel.children}</Offcanvas.Body>
            </Offcanvas>
        </>
    );
}

export default UiSidePanel;
